import type { TenantPodPolicy, TenantSummary } from "../types/api.js";
import { apiRequest } from "./api-client.js";

export async function fetchTenants(token: string): Promise<{ tenants: TenantSummary[] }> {
  return apiRequest<{ tenants: TenantSummary[] }>("/api/v1/tenants", { method: "GET", token });
}

export async function fetchTenantPodSettings(token: string, tenantId: string): Promise<{ settings: TenantPodPolicy }> {
  return apiRequest<{ settings: TenantPodPolicy }>(`/api/v1/tenants/${tenantId}/settings`, {
    method: "GET",
    token,
  });
}
